import Vue from "vue";
import Confirm from "@saas/components/src/components/confirm-order/index";
Vue.use(Confirm);
import { calPrice } from "@saas/service-api/src/joint-purchase/index";
import GroupInfo from "@saas/pages/src/group-activity/components/GroupInfo";
import CourseCard from "@saas/pages/src/group-activity/components/CourseCard";
import { mapGetters } from "vuex";
import { jsToFlutter } from "@saas/components/src/utils/js-to-flutter";
import {
  isMobile,
  isH5,
  isHXApp,
  clipboard,
  splitPrice,
  ShareDrawer,
  isQQ,
  isWeChat,
  getCdnUrl,
} from "@saas/components/src";
import CourseDescription from "@saas/pages/src/product-details/components/CourseDescription.vue";
import OrgCard from "@saas/pages/src/product-details/components/OrgCard.vue";
import LessonList from "@saas/pages/src/product-details/lesson-list/LessonList.vue";
import TipsText from "@saas/pages/src/product-details/components/TipsText.vue";
import {
  getCourseInfo,
  getGroupBuying,
} from "@saas/service-api/src/product-details";
import { getOrganization } from "@saas/service-api/src/organization";
import handleCourseInfo from "@saas/components/src/mixins/handleCourseInfo";
import H5CourseCard from "@saas/pages/src/group-activity/components/H5CourseCard";
import H5LessonList from "@saas/pages/src/product-details/lesson-list/H5LessonList";
export default {
  mixins: [handleCourseInfo],
  data: function () {
    return {
      isMobile: isMobile(),
      id: 0, //团购id
      groupInfo: {}, //团购信息 state:1待成团 2已成团 3拼团失败
      orgInfo: {}, //机构信息
      productInfo: {},
      isH5: isH5(),
      isHXApp: isHXApp(),
      detailNavFixed: false,
      tabFixTop: 0, //tab定位top值(客户端会被topbar遮盖)
      tabList: [
        { id: 1, title: "详情", ref: "detail", className: "ql-snow" },
        { id: 2, title: "课程", ref: "course", className: "course-cont" },
      ],
      activeId: 1,
      isChangeTab: false, //点击tab和监听滚动-高亮tab冲突
      lastTime: 0,
      // scrollLock: false, //点击锚点锁定，不触发滚动内容对导航的影响
      canExceed: false, //是否可超限成团
      isJoined: false, //是否参与该拼团（已付款）
      isElectron: window.isElectron,
      groupEnd: false,
      splitPrice,
      showMemberList: false,
      isWeChat: isWeChat(),
      isQQ: isQQ(),
    };
  },
  mounted() {
    this.apiGetGroupBuying();

    this.$nextTick(() => {
      setTimeout(() => {
        if (window.isElectron) {
          let elMain = document.getElementById("electron-main");
          if (!elMain) return;
          elMain.addEventListener("scroll", this.scrollFunc, true);
          elMain.addEventListener("scroll", this.scrollActiveNav, true);
        } else {
          window.addEventListener("scroll", this.scrollFunc, true);
          window.addEventListener("scroll", this.scrollActiveNav, true);
        }
        if (this.$refs["detail"]) {
          this.canShowAllInfo = this.$refs["detail"].offsetHeight > 4000;
        }
      }, 2000);
    });
  },
  destroyed() {
    //取消监听滚动置顶
    if (window.isElectron) {
      let elMain = document.getElementById("electron-main");
      if (!elMain) return;
      elMain.removeEventListener("scroll", this.scrollFunc, true);
      elMain.removeEventListener("scroll", this.scrollActiveNav, true);
    } else {
      window.removeEventListener("scroll", this.scrollFunc, true);
      window.removeEventListener("scroll", this.scrollActiveNav, true);
    }

    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    jumpOrgPage() {
      let url = `/org/${this.orgInfo.org_id}`;
      if (window.isElectron || this.isMobile) {
        this.$router.push(url);
      } else {
        window.open(url);
      }
    },
    goLearningCenter() {
      this.$router.push(`/course-detail/${this.productInfo.id}`);
    },
    copyShareUrl() {
      const content = `点击链接，一起 ${this.productInfo.group_set_info.price / 100
        } 元拼团购买原价 ${this.productInfo.goods.price / 100} 元的课程《${this.productInfo.course_name
        }》，链接：${process.env.VUE_APP_SAAS_WEB_URL}/group-share/${this.id}`;
      const _this = this;
      clipboard(content, () => {
        _this.$message.success("链接已复制，可以发给好友啦");
      });
    },
    goGroupInfo() {
      let url = `/group-info/${this.groupInfo.group_id}`;
      this.$router.push(url);
    },
    goProductDetail() {
      let url = `/product-detail/${this.productInfo.id}`;
      this.$router.push(url);
    },
    // activity_id:活动ID，团购时，0表示开团，其余表示参团ID
    signUp(activity_id) {
      if (this.isAuthenticated) {
        // 登录
        if (this.loading) return;
        this.loading = true;
        // 付费
        this.apiCalPrice(activity_id);
      } else {
        // 未登录
        this.jumpLoginPage();
      }
    },
    apiCalPrice(activity_id) {
      let { goods, activity_type } = this.productInfo;
      let params = {
        compute: false,
        goods_items: [
          {
            goods_id: goods.id,
            activity_type: 4,
            activity_id,
          },
        ],
      };
      calPrice(params)
        .then((res) => {
          if (res.code === 1) {
            let calPriceData = res.data;
            if (activity_id != null) {
              calPriceData.activity_type = activity_type;
            }
            calPriceData.goods_items = params.goods_items;
            let user = this.user;
            document.querySelector(".share-page").style.display = "none";
            this.$saasConfirmOrder(
              [],
              "confirm-order-container",
              calPriceData,
              user
            );
          } else if (res.code === 55005 && res.data?.order_no) {
            this.$chiralAutoMessage(`您已下单本商品，可继续完成支付`, 1200);
            setTimeout(() => {
              let url = `/confirm-order/${res.data.order_no}?history=1&goods_id=${goods.id}`;
              // 拼团-参团、开团
              if (activity_id !== null) {
                url += `&activity_id=${activity_id}&activity_type=4`;
              }
              this.$router.push(url);
            }, 1200);
          } else {
            this.$message.error(res.message);
          }
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //滚动置顶
    scrollFunc(e) {
      var nowTime = Date.now();
      if (nowTime - this.lastTime) {
        this.lastTime = nowTime;
        let tabHeight =
          document.querySelector(".page-title")?.offsetHeight || 0;
        let courseTopHeight =
          document.querySelector(".page-top-wrap")?.offsetHeight || 0;
        const scrollTop =
          window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          e.target.scrollTop;
        this.detailNavFixed = scrollTop >= tabHeight + courseTopHeight;
        this.tabFixTop = 0;
        if (this.detailNavFixed) {
          if (document.querySelector(".topbar")) {
            let height = document.querySelector(".topbar").offsetHeight;
            this.tabFixTop = height;
          }
        }
      }
    },
    changeTab(item) {
      this.isChangeTab = true;
      this.activeId = item.id;
      if (this.$refs[item.ref]) {
        this.$refs[item.ref].scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
      setTimeout(() => {
        this.isChangeTab = false;
      }, 2000);
      // let targetEl = document.querySelector(`.${item.className}`);
      // if (!targetEl) return;
      // let scrollTop = document.querySelector(`.${item.className}`).offsetTop;
      // let titleHeight =
      //   document.querySelector(".page-title")?.offsetHeight || 0;
      // scrollTop -= titleHeight;
      // if (window.isElectron) {
      //   let elMain = document.getElementById("electron-main");
      //   if (!elMain) return;
      //   let topHeight = document.querySelector(".topbar")?.offsetHeight || 0;
      //   scrollTop -= topHeight;
      //   elMain.scrollTo({ top: scrollTop, behavior: "smooth" });
      // } else {
      //   window.scrollTo({ top: scrollTop, behavior: "smooth" });
      // }
      // setTimeout(() => {
      //   this.isChangeTab = false;
      // }, 2500);
    },
    scrollActiveNav(e) {
      if (this.isChangeTab) return;
      const scrollItems = document.querySelectorAll(".tab-content");
      if (this.timer) {
        clearTimeout(this.timer);
      }
      // if (this.scrollLock) {
      //   this.timer = setTimeout(() => {
      //     this.scrollLock = false;
      //   }, 35);
      //   return;
      // }
      for (let i = this.tabList.length - 1; i >= 0; i--) {
        var scrollTop =
          document.body.scrollTop ||
          document.documentElement.scrollTop ||
          e.target.scrollTop;
        if (scrollItems[i]?.offsetTop) {
          const judge = scrollTop >= scrollItems[i].offsetTop - 136;
          if (judge) {
            this.activeId = this.tabList[i].id;
            break;
          }
        }
      }
    },
    apiGetGroupBuying() {
      this.id = this.$route.params.id;
      getGroupBuying({ id: this.$route.params.id }).then((res) => {
        if (res.code === 1) {
          this.groupInfo = res.data || {};
          // 获取课程信息
          if (res?.data?.course_id) {
            this.apiGetCourseInfo(res.data.course_id);
          }
          // 获取机构信息
          if (res?.data?.org_id) {
            this.apiGetOrganization(res.data.org_id);
          }
          // 团购信息处理
          let { is_join_group, state, member_list, group_num, end_at } =
            res.data || {};
          // 团是否结束
          let now = new Date().getTime();
          if (now > end_at * 1000) {
            this.groupEnd = true;
          }
          if (is_join_group) {
            let userInfo = member_list.filter((member) => {
              return (
                member?.user_id === this.user?.user_id && member.state === 2
              );
            });
            if (userInfo[0]) {
              // 已付款
              this.isJoined = true;
            }
          }
          if (state === 1) {
            // 待成团
            // 已支付-成员数
            let isPayed = member_list.filter((member) => {
              return member.state === 2;
            });
            const num = group_num - isPayed.length;
            this.groupInfo.diffNum = num > 0 ? num : 0;
          }
          // 只展示已支付||待支付成员
          this.groupInfo.memberList = member_list.filter((member) => {
            return [1, 2].includes(member.state);
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    apiGetCourseInfo(course_id) {
      getCourseInfo({ course_id }).then((res) => {
        if (res.code === 1) {
          if (res.data) {
            // 课程报名状态-停止
            if (res.data?.enrollment_state === 3) {
              this.$chiralConfirmMessage("该课程已停止报名");
            }
            // 修改页面标题
            let pageTitle = `拼团-${res.data.course_name}`;
            document.title = pageTitle;
            jsToFlutter("setTitle", { title: pageTitle });
            // 计算课时数-直播课状态处理
            this.productInfo = this.handleCourseInfoData(res.data || {});
            // 处理拼团信息
            if (res.data?.group_set_info?.id) {
              this.productInfo.activity_type = 4;
              // 处理活动状态：1：未开始，2：进行中，3：已结束
              let { start_time, real_end_time, exceed_group } =
                res.data.group_set_info;
              this.canExceed = exceed_group === 1;
              let now = new Date().getTime();
              if (now < start_time * 1000) {
                this.productInfo.group_set_info.activityStatus = 1;
              } else if (now > real_end_time * 1000) {
                this.productInfo.group_set_info.activityStatus = 3;
              } else {
                this.productInfo.group_set_info.activityStatus = 2;
              }
            }
          }
        } else {
          this.$message.error(res.message);
        }
      });
    },
    apiGetOrganization(id) {
      getOrganization({ org_id: id }).then((res) => {
        if (res.code === 1 && res.data) {
          this.orgInfo = res.data;
        }
      });
    },
    jumpLoginPage() {
      if (this.isHXApp) {
        jsToFlutter("login");
      } else {
        // let preRoute = window.location.href;
        // window.location.href = `${process.env.VUE_APP_ADMIN_URL}/login?return_url=${preRoute}`;
        this.$loginDialog();
      }
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated", "user"]),
    // 团长昵称
    leaderNickname() {
      if (this.groupInfo.state === 3 || this.groupEnd) {
        this.showMemberList = false;
        return "该拼团已过期，可发起新拼团";
      } else if (this.groupInfo.state === 2 && !this.canExceed) {
        this.showMemberList = false;
        return "该拼团已拼成，可发起新拼团";
      } else if (this.groupInfo?.member_list?.length) {
        this.showMemberList = true;
        let str = "***邀请你拼团";
        let leader = this.groupInfo.member_list.filter((item) => {
          return item.is_leader === 1;
        });
        if (leader?.length) {
          str = leader[0].nickname.slice(0, 1) + str;
        }
        return str;
      } else {
        this.showMemberList = true;
        return "";
      }
    },
    // 拼团列表提示信息
    userListMessage() {
      if (this.groupInfo.state === 1) {
        // 待成团
        return `再邀 <span style="color: #F03349">${this.groupInfo.diffNum}</span> 人，人满后可开通课程`;
      } else if (this.groupInfo.state === 2 && this.canExceed) {
        return "已成团，可继续加入";
      } else {
        return "";
      }
    },
    userLength() {
      let member = this.groupInfo?.member_list?.length || 0;
      return member + this.groupInfo?.diffNum || 0;
    },
    //机构logo
    handleOrgLogo() {
      if (this.orgInfo?.org_logo) {
        return this.orgInfo.org_logo + "?imageView2/0/w/100";
      } else {
        return getCdnUrl("/cdn/static/images/default_org_logo.png", "?imageView2/0/w/100", "comettech");
      }
    },
  },
  components: {
    GroupInfo,
    CourseCard,
    TipsText,
    LessonList,
    OrgCard,
    CourseDescription,
    H5CourseCard,
    H5LessonList,
    ShareDrawer,
  },
};
